module.exports = __webpack_public_path__ + "static/document/modeleprocuration.fb77c10.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/document/modeleprocuration.pdf
// module id = oJHh
// module chunks = 4